import { ChangeDetectionStrategy, Component, computed, inject, Input, Signal } from '@angular/core';
import { OrAvatarComponent, OrIconComponent } from '@ui-components';
import { ActionModalComponent, ButtonLabels, MODAL_TOKEN, ModalProvider } from '@core';
import { RemoveTeamMemberCommandHandler, UpdateTeamMemberCommandHandler } from '../../application/handlers';
import { TeamsService } from '@teams/infra';
import { TeamMember } from '@teams';

@Component({
  selector: 'lib-manage-team-member',
  templateUrl: './manage-team-member.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [OrAvatarComponent, OrIconComponent],
  providers: [RemoveTeamMemberCommandHandler, UpdateTeamMemberCommandHandler, TeamsService]
})
export class ManageTeamMemberComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly removeTeamMemberCommandHandler: RemoveTeamMemberCommandHandler =
    inject(RemoveTeamMemberCommandHandler);
  private readonly updateTeamMemberCommandHandler: UpdateTeamMemberCommandHandler =
    inject(UpdateTeamMemberCommandHandler);

  // Modal component - must use @Input()
  @Input() member!: TeamMember;
  @Input() teamId!: string;

  readonly autoApproveText: Signal<ButtonLabels> = computed(() => {
    const header: string = this.member?.isAutoApproved ? 'Usuń z listy ulubionych graczy' : 'Ulubiony gracz';
    const text: string = this.member?.isAutoApproved
      ? 'Wyłącz automatyczną akceptację'
      : 'Kliknij, aby gracz byl automatycznie akceptowany';
    return { header, text };
  });

  removePlayer(memberId: string): void {
    this.modalProvider.showModal$({
      component: ActionModalComponent,
      cssClass: 'present-modal',
      componentProps: {
        header: 'Usuwanie gracza z grupki',
        message: 'Czy na pewno chcesz usunąć gracza z grupki?',
        btnOk: 'Tak, usuń',
        btnCancel: 'Anuluj',
        action: () => this.executeRemovePlayer(memberId)
      }
    });
  }

  switchAutoApprove(member: TeamMember): void {
    this.updateTeamMemberCommandHandler
      .update(this.teamId, member.userId, !member.isAutoApproved)
      .subscribe(() => this.modalProvider.dismissAllStoredModals());
  }

  private executeRemovePlayer(memberId: string): void {
    this.removeTeamMemberCommandHandler
      .remove(this.teamId, memberId)
      .subscribe(() => this.modalProvider.dismissAllStoredModals());
  }
}
